import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RiChatSmileFill } from "react-icons/ri";
import { Doughnut } from 'react-chartjs-2';
import { Bar, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import ModalComponent from "../pick_modal";
import axios from "axios";
import { toast } from "react-hot-toast";
import { BASELINE } from "../../../util";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const DigitalAPBCView = ({ setActiveIndex, user, setdashboard }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(true);
    const [Incorrect_questionIds, setIncorrect_questionIds] = useState([]);
    const [Incorrect_frqquestionIds, setIncorrect_frqquestionIds] = useState([]);

    const topMathTopics = findTopMissedTopics(Incorrect_questionIds, "frq");
    const [topic, settopic] = useState(false);
    const [section, setsection] = useState("");
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [lastscore, setlastscore] = useState(0);

    const [avg_sat, setAverageAPScore] = useState(0);
    const [averageMCQ, setAverageMCQ] = useState(0);
    const [averageFRQ, setAverageFRQ] = useState(0);
    const [scorearr, setscorearr] = useState([]);

    // Keep mcqsubjects and frqsubjects state arrays as in original
    const [mcqsubjects, setmcqsubjects] = useState([
        // All the mcq subject data
    ]);

    const [frqsubjects, setfrqsubjects] = useState([
        // All the frq subject data
    ]);

    // Assuming mcqsubjects and frqsubjects are available in the scope
    const mcqIdToNameMap = {};
    mcqsubjects.forEach(subject => {
        subject.subtopics.forEach(subtopic => {
            mcqIdToNameMap[subtopic.id] = subtopic.name;
        });
    });

    const frqIdToNameMap = {};
    frqsubjects.forEach(subject => {
        subject.subtopics.forEach(subtopic => {
            frqIdToNameMap[subtopic.id] = subtopic.name;
        });
    });

    // Function to find topic name in the subjects arrays
    function findTopicNameInSubjects(subjects, topicId) {
        for (const subject of subjects) {
            for (const subtopic of subject.subtopics) {
                if (subtopic.id === topicId) {
                    return subtopic.name;
                }
            }
        }
        return null;
    }

    // Modern dark theme chart styling
    const data2 = {
        labels: [''],
        datasets: [
            {
                label: 'Predicted Score',
                data: [lastscore],
                backgroundColor: 'rgba(59, 130, 246, 0.8)',
                borderRadius: 6,
            },
            {
                label: 'Target Score',
                data: [5],
                backgroundColor: 'rgba(75, 85, 99, 0.4)',
                borderRadius: 6,
            },
        ],
    };

    const options2 = {
        indexAxis: 'y',
        scales: {
            x: {
                max: 5,
                beginAtZero: true,
                grid: {
                    color: 'rgba(75, 85, 99, 0.1)',
                },
                ticks: {
                    color: '#D1D5DB',
                },
            },
            y: {
                ticks: {
                    color: '#D1D5DB',
                },
            }
        },
        plugins: {
            legend: {
                labels: {
                    color: '#D1D5DB',
                }
            }
        },
        maintainAspectRatio: false
    };

    // Helper function to calculate averages
    const calculateAverages = (data) => {
        let apScoreTotal = 0;
        let mcqTotal = 0;
        let frqTotal = 0;
        let incorrectQuestionIDList = []; // To collect all incorrect question IDs
        let count = 0;
        let mcq = []; // Array to hold { id, topic, name } objects for MCQ
        let frq = []; // Array to hold { id, topic, name } objects for FRQ
        let scorearr = []
        data.forEach(item => {
            if (item.type === 'AP_Calc_BC') {
                // Parse eng_score to accumulate APscore, mcq, and frq
                try {
                    const scores = JSON.parse(item.eng_score);
                    apScoreTotal += scores.APscore || 0;
                    scorearr.push(scores.APscore);
                    mcqTotal += scores.mcq || 0;
                    frqTotal += scores.frq || 0;
                    count += 1;
                } catch (error) {
                    console.error("Error parsing eng_score:", error);
                }

                // Parse Incorrect_questionIds to collect all incorrect question IDs
                try {
                    const incorrectIds = JSON.parse(item.Incorrect_questionIds || '[]');
                    if (Array.isArray(incorrectIds)) {
                        incorrectIds.forEach(q => {
                            // Validate that q.question_id and q.topic exist
                            if (!q.question_id || !Array.isArray(q.topic) || q.topic.length === 0) {
                                console.warn("Invalid question format or missing fields:", q);
                                return; // Skip this entry
                            }

                            // Push the question ID to the list for unique counting
                            incorrectQuestionIDList.push(q.question_id);

                            // Determine the topic name based on section
                            const topicId = q.topic[0];
                            let topicName = "Unknown Topic";

                            if (q.section === 'mcq') {
                                topicName = mcqIdToNameMap[topicId] || findTopicNameInSubjects(mcqsubjects, topicId) || `Topic ${topicId}`;
                                mcq.push({ id: q.question_id, topic: topicId, name: topicName });
                            } else if (q.section === 'frqa' || q.section === 'frqb') {
                                topicName = frqIdToNameMap[topicId] || findTopicNameInSubjects(frqsubjects, topicId) || `FRQ Topic ${topicId}`;
                                frq.push({ id: q.question_id, topic: topicId, name: topicName });
                            } else {
                                console.warn("Invalid section in question:", q);
                            }
                        });
                    } else {
                        console.warn("Incorrect_questionIds is not an array:", incorrectIds);
                    }
                } catch (error) {
                    console.error("Error parsing Incorrect_questionIds:", error);
                }
            }
        });

        // Remove duplicate question IDs
        const uniqueIncorrectQuestionIds = [...new Set(incorrectQuestionIDList)];

        // Function to count and sort duplicate topics
        const getDuplicateTopics = (questions, idToNameMap, subjects) => {
            const topicCounts = questions.reduce((acc, curr) => {
                acc[curr.topic] = (acc[curr.topic] || 0) + 1;
                return acc;
            }, {});

            // Convert to array and filter duplicates (count > 1)
            const duplicates = Object.entries(topicCounts)
                .filter(([topic, count]) => count > 1)
                .map(([topic, count]) => {
                    // Try to get a better name from subjects if needed
                    let name = idToNameMap[topic] || findTopicNameInSubjects(subjects, topic) || `Topic ${topic}`;
                    return {
                        topic,
                        name,
                        count
                    };
                });

            // Sort duplicates in descending order of count
            duplicates.sort((a, b) => b.count - a.count);

            return duplicates;
        };

        // Count and sort duplicate topics in MCQ and FRQ
        const duplicateMCQTopics = getDuplicateTopics(mcq, mcqIdToNameMap, mcqsubjects);
        const duplicateFRQTopics = getDuplicateTopics(frq, frqIdToNameMap, frqsubjects);
        
        setscorearr(scorearr);
        const labels = generateLabels(scorearr.length);
        setData3({
            labels: labels,
            datasets: [
                {
                    label: 'AP Calculus BC Score',
                    data: scorearr,
                    fill: false,
                    borderColor: '#3B82F6',
                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                    tension: 0.3,
                    pointBackgroundColor: '#3B82F6',
                    pointBorderColor: '#111827',
                    pointRadius: 5,
                    pointHoverRadius: 7
                }
            ]
        });

        return {
            averageAPScore: count > 0 ? apScoreTotal / count : 0,
            averageMCQ: count > 0 ? mcqTotal / count : 0,
            averageFRQ: count > 0 ? frqTotal / count : 0,
            incorrectQuestionIds: uniqueIncorrectQuestionIds,
            totalIncorrectQuestions: incorrectQuestionIDList.length, // Total with duplicates
            uniqueTotalIncorrectQuestions: uniqueIncorrectQuestionIds.length, // Total unique
            averageIncorrectQuestions: count > 0 ? incorrectQuestionIDList.length / count : 0,
            duplicateMCQTopics, // Sorted array of { topic, count } for duplicated MCQ topics
            duplicateFRQTopics  // Sorted array of { topic, count } for duplicated FRQ topics
        };
    };

    // Function to set the latest APscore
    const setLatestAPScore = (data) => {
        const latestItem = data.find(item => item.type === 'AP_Calc_BC');
        if (latestItem) {
            try {
                const scores = JSON.parse(latestItem.eng_score);
                setlastscore(scores.APscore || 0);
            } catch (error) {
                console.error("Error parsing eng_score for lastscore:", error);
            }
        }
    };

    useEffect(() => {
        if (!user) {
            toast.error("Please login before starting the test");
            navigate("/login"); // Redirect user to the /login page
            return;
        }

        let data = {
            id: user.u_id
        };

        axios.post(BASELINE + 'testresult/get', data)
            .then(response => {
                const reversedData = response.data.slice().reverse(); // Create a copy and reverse

                // Calculate averages
                const averages = calculateAverages(reversedData);
                setAverageAPScore(averages.averageAPScore);
                setAverageMCQ(averages.averageMCQ);
                setAverageFRQ(averages.averageFRQ);
                setIncorrect_questionIds(averages.duplicateMCQTopics);
                setIncorrect_frqquestionIds(averages.duplicateFRQTopics);
                // Set last score
                setLatestAPScore(reversedData);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const handleClose = () => {
        setIsVisible(false);
    };

    const handleRowClick = (subjectName, section) => {
        setsection(section);
        settopic(subjectName);
        setIsModalOpen2(true);
        // You can perform any actions here, such as navigation or displaying details
    };

    function findTopMissedTopics(data, tag) {
        const topicCount = {};

        // Count incorrect topics for the specified tag
        data.forEach(item => {
            if (item.tag === tag && !item.correct) {
                topicCount[item.topic] = (topicCount[item.topic] || 0) + 1;
            }
        });

        // Convert the topicCount object into an array of [topic, count] pairs
        const sortedTopics = Object.entries(topicCount).sort((a, b) => b[1] - a[1]);

        // Select the top 10
        return sortedTopics.slice(0, 10).map(entry => ({ topic: entry[0], count: entry[1] }));
    }

    function generateLabels(length) {
        return Array.from({ length }, (_, index) => `Test ${index + 1}`);
    }

    const [data3, setData3] = useState({
        labels: [], // Will be set after calculation
        datasets: []
    });

    const data4 = {
        labels: [''],
        datasets: [
            {
                label: 'MCQ Max Score',
                data: [45],
                backgroundColor: 'rgba(75, 85, 99, 0.4)',
                borderRadius: 6,
            },
            {
                label: 'MCQ Score',
                data: [averageMCQ],
                backgroundColor: '#3B82F6',
                borderRadius: 6,
            }
        ],
    };

    const options4 = {
        indexAxis: 'y',
        scales: {
            x: {
                max: 45,
                beginAtZero: true,
                grid: {
                    color: 'rgba(75, 85, 99, 0.1)',
                },
                ticks: {
                    color: '#D1D5DB',
                },
            },
            y: {
                ticks: {
                    color: '#D1D5DB',
                },
            }
        },
        plugins: {
            legend: {
                labels: {
                    color: '#D1D5DB',
                }
            }
        },
        maintainAspectRatio: false
    };

    const data5 = {
        labels: [''],
        datasets: [
            {
                label: 'FRQ Max Score',
                data: [54],
                backgroundColor: 'rgba(75, 85, 99, 0.4)',
                borderRadius: 6,
            },
            {
                label: 'FRQ Score',
                data: [averageFRQ],
                backgroundColor: '#3B82F6',
                borderRadius: 6,
            }
        ],
    };

    const options5 = {
        indexAxis: 'y',
        scales: {
            x: {
                max: 54,
                beginAtZero: true,
                grid: {
                    color: 'rgba(75, 85, 99, 0.1)',
                },
                ticks: {
                    color: '#D1D5DB',
                },
            },
            y: {
                ticks: {
                    color: '#D1D5DB',
                },
            }
        },
        plugins: {
            legend: {
                labels: {
                    color: '#D1D5DB',
                }
            }
        },
        maintainAspectRatio: false
    };

    // Options for the line graph
    const options3 = {
        scales: {
            y: {
                beginAtZero: false,
                suggestedMax: 5,
                grid: {
                    color: 'rgba(75, 85, 99, 0.1)',
                },
                ticks: {
                    color: '#D1D5DB',
                }
            },
            x: {
                grid: {
                    color: 'rgba(75, 85, 99, 0.1)',
                },
                ticks: {
                    color: '#D1D5DB',
                }
            }
        },
        plugins: {
            legend: {
                labels: {
                    color: '#D1D5DB',
                }
            }
        },
        maintainAspectRatio: false
    };

    const data = {
        datasets: [{
            data: [avg_sat, 5 - avg_sat],
            backgroundColor: ['#3B82F6', '#1F2937'],
            hoverBackgroundColor: ['#2563EB', '#374151'],
            borderWidth: 0,
        }],
        labels: ['Score', 'Remaining'],
    };

    return (
        <div className="bg-gray-900 text-gray-200 min-h-screen">
            <ModalComponent topic={topic} isOpen={isModalOpen2} onClose={setIsModalOpen2} section={'Apcalcab'} type={'AP_Calc_AB'} />
            
            {/* Header */}
            <div className="p-4 md:p-6">
                <div className="w-full max-w-[100%]">
                    <h1 className="text-2xl md:text-3xl font-bold text-white border-l-4 border-blue-500 pl-4 mb-6">AP Calculus BC Dashboard</h1>
                </div>
            </div>

            {/* Latest Score Section */}
            <div className="px-4 md:px-6 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Score Card */}
                    <div className="bg-gray-800 rounded-lg overflow-hidden shadow-xl border-l-4 border-blue-500">
                        <div className="p-6">
                            <div className="flex items-center mb-4">
                                <div className="h-8 w-1 bg-blue-500 mr-3"></div>
                                <span className="text-xl font-medium">Latest AP Score</span>
                            </div>
                            
                            <div className="flex items-center">
                                <div className="text-6xl font-bold text-blue-400">{lastscore}</div>
                                <div className="ml-4 text-gray-400 text-xl"> of 5 points</div>
                            </div>
                            
                            <div className="mt-6 text-sm text-gray-400">
                                Complete your unfinished tests to get a complete analytics report.
                            </div>
                        </div>
                    </div>

                    {/* Score Comparison */}
                    <div className="bg-gray-800 rounded-lg overflow-hidden shadow-xl">
                        <div className="p-6 h-full">
                            <div className="text-lg font-medium mb-4 text-gray-300 border-l-2 border-blue-500 pl-3">Your Score vs. Target</div>
                            <div className="h-64">
                                <Bar data={data2} options={options2} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Score Averages Section */}
            <div className="px-4 md:px-6 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* Overall Average */}
                    <div className="bg-gray-800 rounded-lg shadow-xl p-5">
                        <h2 className="text-lg font-medium mb-3 text-gray-300 border-l-2 border-blue-500 pl-3">Overall Average AP Score</h2>
                        <div className="flex items-center justify-center h-48">
                            <Doughnut
                                data={data}
                                options={{
                                    maintainAspectRatio: false,
                                    cutout: '70%',
                                    plugins: {
                                        legend: {
                                            display: false
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div className="text-center mt-3">
                            <span className="text-3xl font-bold text-blue-400">{avg_sat.toFixed(1)}</span>
                            <span className="text-gray-400 text-sm ml-1"> / 5</span>
                        </div>
                    </div>

                    {/* MCQ Scores */}
                    <div className="bg-gray-800 rounded-lg shadow-xl p-5">
                        <h2 className="text-lg font-medium mb-3 text-gray-300 border-l-2 border-blue-500 pl-3">MCQ Average Score</h2>
                        <div className="h-48 flex items-center">
                            <Bar data={data4} options={options4} />
                        </div>
                        <div className="text-center mt-3">
                            <span className="text-lg font-medium text-gray-400">
                                {averageMCQ.toFixed(1)} out of 45 points
                            </span>
                        </div>
                    </div>
                    
                    {/* FRQ Scores */}
                    <div className="bg-gray-800 rounded-lg shadow-xl p-5">
                        <h2 className="text-lg font-medium mb-3 text-gray-300 border-l-2 border-blue-500 pl-3">FRQ Average Score</h2>
                        <div className="h-48 flex items-center">
                            <Bar data={data5} options={options5} />
                        </div>
                        <div className="text-center mt-3">
                            <span className="text-lg font-medium text-gray-400">
                                {averageFRQ.toFixed(1)} out of 54 points
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Recommended Topics Section */}
            <div className="px-4 md:px-6 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* MCQ Missing Topics */}
                    <div className="bg-gray-800 rounded-lg shadow-xl overflow-hidden">
                        <div className="p-5">
                            <div className="flex items-center mb-4">
                                <div className="h-8 w-1 bg-blue-500 mr-3"></div>
                                <span className="text-lg font-medium">Recommended MCQ Topics</span>
                            </div>
                            
                            <div className="bg-gray-900 bg-opacity-50 rounded-lg p-4 overflow-auto h-64 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-900">
                                {Incorrect_questionIds.length > 0 ? (
                                    <ul className="space-y-2">
                                        {Incorrect_questionIds.map((topic, index) => (
                                            <li
                                                key={index}
                                                onClick={() => handleRowClick(topic.topic, "mcq")}
                                                className="flex justify-between items-center p-3 bg-gray-800 rounded-md cursor-pointer hover:bg-gray-700 transition-all duration-200 group"
                                            >
                                                <span className="text-sm text-gray-300 group-hover:text-white mr-2">
                                                    {topic.name !== "Unknown Topic" ? topic.name : mcqIdToNameMap[topic.topic] || `Topic ${topic.topic}`}
                                                </span>
                                                <span className="px-2 py-1 bg-blue-900 text-blue-200 text-xs rounded-full">
                                                    {topic.count}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="text-center text-gray-500 py-10">
                                        No MCQ topics data available
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* FRQ Missing Topics */}
                    <div className="bg-gray-800 rounded-lg shadow-xl overflow-hidden">
                        <div className="p-5">
                            <div className="flex items-center mb-4">
                                <div className="h-8 w-1 bg-blue-500 mr-3"></div>
                                <span className="text-lg font-medium">Recommended FRQ Topics</span>
                            </div>
                            
                            <div className="bg-gray-900 bg-opacity-50 rounded-lg p-4 overflow-auto h-64 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-900">
                                {Incorrect_frqquestionIds.length > 0 ? (
                                    <ul className="space-y-2">
                                        {Incorrect_frqquestionIds.map((topic, index) => (
                                            <li
                                                key={index}
                                                onClick={() => handleRowClick(topic.topic, "frq")}
                                                className="flex justify-between items-center p-3 bg-gray-800 rounded-md cursor-pointer hover:bg-gray-700 transition-all duration-200 group"
                                            >
                                                <span className="text-sm text-gray-300 group-hover:text-white mr-2">
                                                    {topic.name !== "Unknown Topic" ? topic.name : frqIdToNameMap[topic.topic] || `FRQ Topic ${topic.topic}`}
                                                </span>
                                                <span className="px-2 py-1 bg-blue-900 text-blue-200 text-xs rounded-full">
                                                    {topic.count}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="text-center text-gray-500 py-10">
                                        No FRQ topics data available
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Overall Score Chart */}
            <div className="px-4 md:px-6">
                <div className="bg-gray-800 rounded-lg shadow-xl p-5">
                    <h2 className="text-lg font-medium mb-4 text-gray-300 border-l-2 border-blue-500 pl-3">AP Score Progress</h2>
                    
                    <div className="h-72">
                        <Line data={data3} options={options3} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DigitalAPBCView;